<template>
  <button type="button" class="btn btn-primary" :disabled="busy" @click="connect">
    <span v-if="busy" class="spinner-border spinner-border-sm mr-1" aria-hidden="true"></span>
    <i v-else class="fas fa-wallet mr-1"></i>
    {{ label }}
  </button>
</template>

<script>
import { connectWallet } from '@/utils/wallet';

/** Connects the wallet in place (see utils/wallet.js); the page reacts to the connected account by itself. */
export default {
  name: 'ConnectWalletButton',
  props: { label: { type: String, default: 'Connect wallet' } },
  data() {
    return { busy: false };
  },
  methods: {
    async connect() {
      this.busy = true;
      try {
        await connectWallet(this.$store, this.$router);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
